import { CustomerState } from "../customer.slice.ts";
import { PayloadAction } from "@reduxjs/toolkit";
import { MaritalStatusRequest } from "../../../../orchestrator-api-client";

export const submitMaritalStatusReducer = (
  state: CustomerState,
  action: PayloadAction<MaritalStatusRequest>,
) => {
  state.family.maritalStatus = action.payload.maritalStatus!; // TODO: Must be set as non-nullable on swagger
};
